/* @flow */
import React from 'react';
import Dialog from 'components/Dialog.jsx';
import BoxBody from 'components/BoxBody.jsx';
import ShareRemind from 'user/components/ShareRemind.jsx';

class ShareRemindModal extends React.Component {
  render() {
    return (
      <Dialog
        eventScreenName="ShareRemindModal"
        className="ShareRemindModal"
        {...this.props}
        size="small">
        <BoxBody>
          <ShareRemind {...this.props} />
        </BoxBody>
      </Dialog>
    );
  }
}

export default ShareRemindModal;



// WEBPACK FOOTER //
// ./src/user/components/ShareRemindModal.jsx